import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

// 截取页面导出pdf混合函数
export const ExportToPdf = {
  data() {
    return {
      exportPdfLoading: false,
    }
  },
  methods: {
    // 分页导出pdf
    exportToPdf(element, title) {
      this.exportPdfLoading = true
      // 使用html2canvas将内容转换为PNG图片
      html2canvas(element, {
        useCORS: true, // 允许使用跨域图像
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/jpeg')

          // 创建一个新的jsPDF实例
          const pdf = new jsPDF()
          const imgWidth = 210 - 20 // A4页面宽度减去左右内边距（20mm）
          const pageHeight = pdf.internal.pageSize.height // 获取PDF页面高度

          const imgHeight = (canvas.height * imgWidth) / canvas.width // 根据比例计算图片高度
          let heightLeft = imgHeight // 剩余高度
          let position = 10 // 初始位置（顶部内边距10mm）

          // 分页处理
          while (heightLeft >= 0) {
            pdf.addImage(imgData, 'JPEG', 10, position, imgWidth, imgHeight) // 左右各10mm内边距
            heightLeft -= pageHeight // 减去页面高度
            position -= pageHeight // 移动位置至下一页
            if (heightLeft >= 0) {
              pdf.addPage() // 需要新页面时，添加新页面
            }
          }

          // 保存PDF文件
          pdf.save(`${title}.pdf`)
        })
        .finally(() => {
          this.exportPdfLoading = false
        })
    },
    // 导出为单页长PDF（修正右边距问题）
    exportLongImgToPdf(element, title, canvasConfig = {}) {
      this.exportPdfLoading = true

      html2canvas(element, {
        useCORS: true,
        backgroundColor: '#ffffff', // 截图背景色
        logging: false,
        windowWidth: Math.max(element.scrollWidth, window.innerWidth),
        windowHeight: element.scrollHeight,
        allowTaint: true,
        ...canvasConfig,
      })
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/jpeg', 1.0)

          // PDF参数
          const pdfWidth = 210 // A4宽度(mm)
          const margin = 10 // 边距(mm)
          const contentWidth = pdfWidth - margin * 2 // 内容宽度190mm

          // 计算内容高度（保持宽高比）
          const imgHeight = (canvas.height * contentWidth) / canvas.width

          // 最终PDF高度
          const pdfHeight = imgHeight + margin * 2

          // 创建PDF
          const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [pdfWidth, pdfHeight],
          })

          // 设置灰色背景 - 在整个PDF页面绘制灰色矩形
          const grayColor = '#ffffff' // 浅灰色，可根据需要调整
          pdf.setFillColor(grayColor)
          pdf.rect(0, 0, pdfWidth, pdfHeight, 'F') // 'F'表示填充

          // 添加图片（左右边距10mm，上边距10mm）
          pdf.addImage(imgData, 'JPEG', margin, margin, contentWidth, imgHeight)

          pdf.save(`${title}.pdf`)
        })
        .catch((error) => {
          console.error('导出PDF失败:', error)
        })
        .finally(() => {
          // 恢复原始样式
          this.exportPdfLoading = false
        })
    },
  },
}
